const config = {
  __DEV__: true,
  API_BASEURL: "http://localhost:4041/api/",
  env: "development",
  SITE_URL: "http://localhost:3001",
  requireAuth: false,
  LIBRARY_URL: "http://library.bdrc.io",
  TEMPLATES_BASE: "http://purl.bdrc.io/",
}

export default config
